import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import ExploreRoles from './Links/ExploreRoles';

const Header = ({ title }: { title: string }) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="ml-[20px] mr-[14px] mt-[20px] border-[1px] border-[#eeeeee] p-3 rounded-[10px]">
      <div className="flex items-center justify-between">
        <span className="flex gap-3">
          <span
            className="flex gap-3 items-center font-bold cursor-pointer"
            onClick={goBack}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="size-6 cursor-pointer"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
              />
            </svg>
            Back
          </span>
          <div className="text-[#a8a8a8]">
            {'>'} Branch {'>'} {title}
          </div>
        </span>
        {/* <span className="flex gap-3">
          right
        </span> */}
      </div>
    </div>
  );
};

export default Header;
